module.exports = __webpack_public_path__ + "img/jackpot-preview.effe439d.png";